import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';
import { FamilyListItemFragment } from './FamilyListItemFragment';

const CreateFamilyMutation = graphql.persisted(
  "CreateFamily",
  graphql(`
    mutation CreateFamily($input: CreateFamilyInput!) {
      createFamily(input: $input) {
        school {
          id
          families {
            ...FamilyListItemFragment
          }
        }
        family {
          id
          slug
        }
        userErrors {
          message
          path
        }
      }
    }
  `, [FamilyListItemFragment])
);

export { CreateFamilyMutation };

export function useCreateFamily() {
  return useMutation(CreateFamilyMutation);
}
